import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface LandscapingProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Landscaping: React.FC<LandscapingProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [landscaping, setLandscaping] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Landscaping'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], Landscaping: v } } })
    );
    const label = 'Landscaping';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={landscaping}
                />
            ) : (
                <TextBox
                    value={landscaping ?? ''}
                    onChange={(value) => setLandscaping(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
